/** A titled source that entered a cognition turn's context — from
 *  `turn_complete.sources`. `ref` is the engine's opaque session handle;
 *  `documentId` only arrives for diagnostic audiences (owner / staff).
 *  Identifiers never appear in prose; provenance is shown by title. */
export interface TurnSource {
  ref: string;
  title: string;
  kind: string;
  documentId?: string;
}

/** Parse `turn_complete.sources` defensively; unknown shapes yield undefined. */
export function parseTurnSources(raw: unknown): TurnSource[] | undefined {
  if (!Array.isArray(raw)) return undefined;
  const out: TurnSource[] = [];
  for (const item of raw) {
    if (!item || typeof item !== 'object') continue;
    const r = item as Record<string, unknown>;
    const title = typeof r.title === 'string' ? r.title.trim() : '';
    if (!title) continue;
    out.push({
      ref: typeof r.ref === 'string' ? r.ref : '',
      title,
      kind: typeof r.kind === 'string' ? r.kind : 'document',
      // A partner's knowledge shared through a tag is sealed: never carried by id.
      ...(r.sealed !== true && r.kind !== 'shared' && typeof r.document_id === 'string' && r.document_id
        ? { documentId: r.document_id }
        : {}),
    });
  }
  return out.length > 0 ? out : undefined;
}
